import {
  AcademiesIcon,
  AccessControlIcon,
  AccessMangIcon,
  AmenitiesIcon,
  BugIcon,
  DocIcon,
  EventsIcon,
  DiningIcon,
  GymIcon,
  HomeIcon,
  ArticlesIcon,
  ProductConfigIcon,
  SettingsIcon,
  TrainingIcon,
  UserRolesIcon,
  MembersIcon,
  WalletIcon,
  RolesIcon,
  UsersIcon,
  BranchesManagementIcon,
  LanguagesIcon,
  OnboardingScreensIcon,
  ModulesControlIcon,
  CancellationReasonsIcon,
  RatingReasonsIcon,
  DashboardIcon,
  MemberRenewalIcon,
  InterestsIcon,
  ReferralsIcon,
  ReferralsSettingsIcon,
  TransactionsHistoryIcon,
  ReportedTransactionsIcon,
  WalletSettingsIcon,
  GuestInvitationsIcon,
  FamilyBalanceIcon,
  TicketsTypeIcon,
  FAQsIcon,
  TutorialsIcon,
  SupportingPagesIcon,
  SupportInfoIcon,
  TicketsCategoriesIcon,
  DirectingEmailsIcon,
  AdsBannerIcon,
  HighlightsIcon,
  AmenitiesManagementIcon,
  NotificationsIcon,
  OrdersHistoryIcon,
  RatingsIcon,
  WaitersIcon,
  WaitersOrdersIcon,
  DeliveryZonesIcon,
  RentalActivitiesIcon,
  BookingsIcon,
  CalendarIcon,
  InvitationsIcon,
  RentedEquipmentsIcon,
  TrainersListingIcon,
  TrainersReservationsIcon,
  TrainersPaymentsIcon,
  AssetsSetupIcon,
  AllBookingsIcon,
  FullCalendarIcon,
  TrainingActivitiesIcon,
  PackagesManagementIcon,
  WaitingListIcon,
  TagsCategoriesIcon,
  ReactionsIcon,
  EventsListingIcon,
  CancellationIcon,
  MainInfoIcon,
  SubscriptionsPlansIcon,
  DropInsIcon,
  AcademyMainInfoIcon,
  AcademyStructureIcon,
  AcademySubscriptionPlansIcon,
  AcademySeasonIcon,
  AcademyBookingIcon,
  AcademyCalenderIcon,
  AcademyRatingsAndReviewIcon,
  AcademyAssetsIcon,
  AcademyTrainersIcon,
  AcademyWaitingListIcon,
  AssetsIcon,
  TicketsIcon,
} from "@/components/icons/sidebar-icon";
import { SideBarItem } from "./types";
import { CornerLeftUpIcon, GitPullRequest } from "lucide-react";

const userManagementItems = [
  {
    title: "Roles",
    icon: <RolesIcon />,
    link: "/users-management/roles",
  },
  {
    title: "Users",
    icon: <UsersIcon />,
    link: "/users-management/users",
  },
];

const configurationItems = [
  {
    title: "Club Settings",
    icon: <SettingsIcon />,
    link: "/configurations/club-settings",
  },
  {
    title: "Branches Management",
    icon: <BranchesManagementIcon />,
    link: "/configurations/branches-management",
  },
  {
    title: "Languages",
    icon: <LanguagesIcon />,
    link: "/configurations/languages",
  },
  {
    title: "Onboarding Screens",
    icon: <OnboardingScreensIcon />,
    link: "/configurations/onboarding-screens",
  },
  {
    title: "Modules Control",
    icon: <ModulesControlIcon />,
    link: "/configurations/modules-control",
  },
  {
    title: "Cancellation Reasons",
    icon: <CancellationReasonsIcon />,
    link: "/configurations/cancellation-reasons",
  },
  {
    title: "Rating Reasons",
    icon: <RatingReasonsIcon />,
    link: "/configurations/rating-reasons",
  },
];

const crmItems = [
  // {
  //   title: "Dashboard",
  //   icon: <DashboardIcon />,
  //   link: "/crm/dashboard",
  // },
  {
    title: "Members",
    icon: <MembersIcon />,
    link: "/crm/members",
  },
  // {
  //   title: "Friends",
  //   icon: <UserRolesIcon />,
  //   link: "/crm/friends",
  // },
  // {
  //   title: "Referrals Program",
  //   icon: <ReferralsIcon />,
  //   link: "/crm/referrals-program",
  //   subLinks: [
  //     {
  //       title: "Referrals",
  //       icon: <ReferralsIcon />,
  //       link: "/crm/referrals-program/referrals",
  //     },
  //     {
  //       title: "Referral Settings",
  //       icon: <ReferralsSettingsIcon />,
  //       link: "/crm/referrals-program/referral-settings",
  //     },
  //   ],
  // },
  // {
  //   title: "Membership Renewals",
  //   icon: <MemberRenewalIcon />,
  //   link: "/crm/membership-renewals",
  // },
  {
    title: "Interests",
    icon: <InterestsIcon />,
    link: "/crm/interests",
  },
];

const walletItems = [
  // {
  //   title: "Dashboard",
  //   icon: <DashboardIcon />,
  //   link: "/wallet/dashboard",
  // },
  {
    title: "Wallets Management",
    icon: <WalletIcon />,
    link: "/wallet/wallets-management",
  },
  {
    title: "Transcations History",
    icon: <TransactionsHistoryIcon />,
    link: "/wallet/transactions-history",
  },
  // {
  //   title: "Reported Transactions",
  //   icon: <ReportedTransactionsIcon />,
  //   link: "/wallet/reported-transactions",
  // },
  {
    title: "Wallet Settings",
    icon: <WalletSettingsIcon />,
    link: "/wallet/wallet-settings",
  },
];

const accessControlItems = [
  // {
  //   title: "Dashboard",
  //   icon: <DashboardIcon />,
  //   link: "/access-control/dashboard",
  // },
  {
    title: "Members Passes",
    icon: <AccessControlIcon />,
    link: "/access-control/members-passes",
  },
  {
    title: "Guest Invitations",
    icon: <GuestInvitationsIcon />,
    link: "/access-control/guests-invitations",
  },
  {
    title: "Tickets Types",
    icon: <WalletIcon />,
    link: "/access-control/ticket-types",
  },
  {
    title: "Settings",
    icon: <WalletSettingsIcon />,
    link: "/access-control/settings",
  },
];

const customerSupportItems = [
  // {
  //   title: "Dashboard",
  //   icon: <DashboardIcon />,
  //   link: "/customer-support/dashboard",
  // },
  {
    title: "Tickets",
    icon: <TicketsIcon />,
    link: "/customer-support/tickets",
  },
  {
    title: "FAQs",
    icon: <FAQsIcon />,
    link: "/customer-support/faqs",
  },
  {
    title: "Tutorials",
    icon: <TutorialsIcon />,
    link: "/customer-support/tutorials",
  },
  {
    title: "Supporting Pages",
    icon: <SupportingPagesIcon />,
    link: "/customer-support/supporting-pages",
  },
  {
    title: "Settings",
    icon: <SettingsIcon />,
    subLinks: [
      {
        title: "Support Info",
        icon: <SupportInfoIcon />,
        link: "/customer-support/settings/support-info",
      },
      {
        title: "Tickets Categories",
        icon: <TicketsCategoriesIcon />,
        link: "/customer-support/settings/tickets-categories",
      },
      {
        title: "Directing Emails",
        icon: <DirectingEmailsIcon />,
        link: "/customer-support/settings/directing-emails",
      },
    ],
  },
];

const marketingItems = [
  {
    title: "Ads Banner",
    icon: <AdsBannerIcon />,
    link: "/marketing/ads-banner",
  },
  // {
  //   title: "HighLights",
  //   icon: <HighlightsIcon />,
  //   link: "/marketing/highlights",
  // },
  {
    title: "Amenities Management",
    icon: <AmenitiesManagementIcon />,
    link: "/marketing/amenities-management",
  },
  {
    title: "Notifications",
    icon: <NotificationsIcon />,
    link: "/marketing/notifications",
  },
];

const diningItems = [
  // {
  //   title: "Dashboard",
  //   icon: <DashboardIcon />,
  //   link: "/dining/dashboard",
  // },
  {
    title: "Restaurants",
    icon: <DiningIcon />,
    link: "/dining/restaurants",
  },
  // {
  //   title: "Orders History",
  //   icon: <OrdersHistoryIcon />,
  //   link: "/dining/orders-history",
  // },
  // {
  //   title: "Ratings",
  //   icon: <RatingsIcon />,
  //   link: "/dining/ratings",
  // },
  // {
  //   title: "Delivery Management",
  //   icon: <WaitersIcon />,
  //   subLinks: [
  //     {
  //       title: "Waiters",
  //       icon: <WaitersIcon />,
  //       link: "/dining/delivery-management/waiters",
  //     },
  //     {
  //       title: "Waiters Orders",
  //       icon: <WaitersOrdersIcon />,
  //       link: "/dining/delivery-management/waiters-orders",
  //     },
  //     {
  //       title: "Delivery Zones",
  //       icon: <DeliveryZonesIcon />,
  //       link: "/dining/delivery-management/delivery-zones",
  //     },
  //   ],
  // },
  {
    title: "Delivery Management",
    icon: <WaitersIcon />,
    link: "/dining/delivery-management",
  },
  // {
  //   title: "Dining Settings",
  //   icon: <WalletSettingsIcon />,
  //   link: "/dining/dining-settings",
  // },
];

const assetsRentalItems = [
  // {
  //   title: "Dashboard",
  //   icon: <DashboardIcon />,
  //   link: "/assets-rental/dashboard",
  // },
  {
    title: "Assets Management",
    icon: <AccessMangIcon />,
    link: "/assets-rental/assets-management",
  },
  {
    title: "All Assets",
    icon: <AccessMangIcon />,
    link: "/assets-rental/all-assets",
  },
  // {
  //   title: "all Reservations",
  //   icon: <BookingsIcon />,
  //   link: "/assets-rental/reservations",
  // },
  // {
  //   title: "Ratings & Reviews",
  //   icon: <RatingsIcon />,
  //   link: "/assets-rental/rating-and-reviews",
  // },
  // {
  //   title: "Settings",
  //   icon: <WalletSettingsIcon />,
  //   link: "/assets-rental/settings",
  // },
];

const trainersItems = [
  // {
  //   title: "Trainers Listing",
  //   icon: <TrainersListingIcon />,
  //   link: "/trainers/trainers-listing",
  // },
  // {
  //   title: "Trainers Reservations",
  //   icon: <TrainersReservationsIcon />,
  //   link: "/trainers/trainers-reservations",
  // },
  // {
  //   title: "Trainers Payments",
  //   icon: <TrainersPaymentsIcon />,
  //   link: "/trainers/trainers-payments",
  // },
];

const academiesItems = [
  // {
  //   title: "Dashboard",
  //   icon: <DashboardIcon />,
  //   link: "/academies/dashboard",
  // },
  {
    title: "Academies Management",
    icon: <AcademiesIcon />,
    link: "/academies/academies-management",
    parent: true,
  },
  // {
  //   title: "Assets Setup",
  //   icon: <AssetsSetupIcon />,
  //   link: "/academies/assets-setup",
  // },
  // {
  //   title: "Coaches Setup",
  //   icon: <TrainingIcon />,
  //   link: "/academies/coaches-setup",
  // },
  // {
  //   title: "All Bookings",
  //   icon: <AllBookingsIcon />,
  //   link: "/academies/all-bookings",
  // },
  // {
  //   title: "Full Calendar",
  //   icon: <FullCalendarIcon />,
  //   link: "/academies/full-calendar",
  // },
  // {
  //   title: "Ratings",
  //   icon: <RatingsIcon />,
  //   link: "/academies/ratings",
  // },
  // {
  //   title: "Settings",
  //   icon: <WalletSettingsIcon />,
  //   link: "/academies/settings",
  // },
];

const performancePlusItems = [
  // {
  //   title: "Dashhboard",
  //   icon: <DashboardIcon />,
  //   link: "/performance-plus/dashboard",
  // },
  {
    title: "Sports Management",
    icon: <TrainingActivitiesIcon />,
    link: "/performance-plus/sports-management",
  },
  {
    title: "Tags Management",
    icon: <TrainingIcon />,
    link: "/performance-plus/tags-management",
  },
  // {
  //   title: "Category Management",
  //   icon: <PackagesManagementIcon />,
  //   link: "/performance-plus/category-management",
  // },
  // {
  //   title: "Instructors Management",
  //   icon: <BookingsIcon />,
  //   link: "/performance-plus/instructors-management",
  // },
  // {
  //   title: "Assets Management",
  //   icon: <WaitingListIcon />,
  //   link: "/performance-plus/assets-management",
  // },
  // {
  //   title: "Calendar",
  //   icon: <RatingsIcon />,
  //   link: "/performance-plus/ratings",
  // },
  // {
  //   title: "Settings",
  //   icon: <WalletSettingsIcon />,
  //   link: "/performance-plus/settings",
  // },
];

const newsAndArticlesItems = [
  // {
  //   title: "Tags Categoeries",
  //   icon: <TagsCategoriesIcon />,
  //   link: "/news-articles/tags-categories",
  // },
  // {
  //   title: "Articles",
  //   icon: <ArticlesIcon />,
  //   link: "/news-articles/articles",
  // },
  // {
  //   title: "Reactions",
  //   icon: <ReactionsIcon />,
  //   link: "/news-articles/reactions",
  // },
];

const eventsItems = [
  // {
  //   title: "Dashhboard",
  //   icon: <DashboardIcon />,
  //   link: "/events/dashboard",
  // },
  // {
  //   title: "Events Listing",
  //   icon: <EventsListingIcon />,
  //   link: "/events/events-listing",
  // },
  // {
  //   title: "Tickets Types",
  //   icon: <TicketsTypeIcon />,
  //   link: "/events/tickets-types",
  // },
  // {
  //   title: "Bookings",
  //   icon: <BookingsIcon />,
  //   link: "/events/bookings",
  // },
  // {
  //   title: "Cancellation",
  //   icon: <CancellationIcon />,
  //   link: "/events/cancellation",
  // },
  // {
  //   title: "Ratings",
  //   icon: <RatingsIcon />,
  //   link: "/events/ratings",
  // },
  // {
  //   title: "Settings",
  //   icon: <WalletSettingsIcon />,
  //   link: "/events/settings",
  // },
];

const gymItems = [
  {
    title: "Dashhboard",
    icon: <DashboardIcon />,
    link: "/gym/dashboard",
  },
  {
    title: "Main Info",
    icon: <MainInfoIcon />,
    link: "/gym/main-info",
  },
  {
    title: "Subscription Plans",
    icon: <SubscriptionsPlansIcon />,
    link: "/gym/subscription-plans",
  },
  {
    title: "Subscription Plan Bookings",
    icon: <BookingsIcon />,
    link: "/gym/bookings",
  },
  // {
  //   title: "Drop Ins",
  //   icon: <DropInsIcon />,
  //   link: "/gym/drop-ins",
  // },

  // {
  //   title: "Cancellation Requests",
  //   icon: <CancellationIcon />,
  //   link: "/gym/cancellation-requests",
  // },
  // {
  //   title: "Settings",
  //   icon: <WalletSettingsIcon />,
  //   link: "/gym/settings",
  // },
];

export const sidebarItems = [
  {
    title: "Home",
    icon: <HomeIcon />,
    link: "/",
    url: "",
  },
  {
    title: "Users Management",
    icon: <UserRolesIcon />,
    sidebarItemsLinks: userManagementItems,
    url: "users-management",
  },
  {
    title: "Configurations",
    icon: <SettingsIcon />,
    sidebarItemsLinks: configurationItems,
    url: "configurations",
  },
  {
    title: "CRM",
    icon: <MembersIcon />,
    sidebarItemsLinks: crmItems,
    url: "crm",
  },
  {
    title: "Wallet",
    icon: <WalletIcon />,
    sidebarItemsLinks: walletItems,
    url: "wallet",
  },
  {
    title: "Access Control",
    icon: <AccessControlIcon />,
    sidebarItemsLinks: accessControlItems,
    url: "access-control",
  },
  {
    title: "Customer Support",
    icon: <TicketsIcon />,
    sidebarItemsLinks: customerSupportItems,
    url: "customer-support",
  },
  {
    title: "Marketing",
    icon: <AmenitiesIcon />,
    sidebarItemsLinks: marketingItems,
    url: "marketing",
  },
  {
    title: "Dining",
    icon: <DiningIcon />,
    sidebarItemsLinks: diningItems,
    itemLinkSidebarItems: [
      {
        title: "Main Info",
        icon: <AcademyMainInfoIcon />,
        link: "/main-info",
      },
      {
        title: "Products",
        icon: <ProductConfigIcon />,
        link: "/products",
      },
      {
        title: "Orders",
        icon: <OrdersHistoryIcon />,
        link: "/orders",
      },
      // {
      //   title: "Cancellation",
      //   icon: <CancellationIcon />,
      //   link: "/cancellation",
      // },
      // {
      //   title: "Rating & Reviews",
      //   icon: <RatingsIcon />,
      //   link: "/ratings-reviews",
      // },
    ],
    url: "dining",
  },
  {
    title: "Assets Rental",
    icon: <AccessMangIcon />,
    sidebarItemsLinks: assetsRentalItems,
    itemLinkSidebarItems: [
      {
        title: "Main Info",
        icon: <AcademyMainInfoIcon />,
        link: "/main-info",
      },
      {
        title: "Assets",
        icon: <AssetsIcon />,
        link: "/assets",
      },
      {
        title: "Bookings",
        icon: <AcademyBookingIcon />,
        link: "/bookings",
      },
      // {
      //   title: "Cancellation",
      //   icon: <CancellationReasonsIcon />,
      //   link: "/cancellation",
      // },
      {
        title: "Calendar",
        icon: <CalendarIcon />,
        link: "/calendar",
      },
      // {
      //   title: "Ratings & Reviews",
      //   icon: <AcademyRatingsAndReviewIcon />,
      //   link: "/ratings-and-reviews",
      // },
    ],
    url: "assets-rental",
  },
  // {
  //   title: "Trainers",
  //   icon: <TrainersReservationsIcon />,
  //   sidebarItemsLinks: trainersItems,
  //   url: "trainers",
  // },
  {
    title: "Academies",
    icon: <AcademiesIcon />,
    sidebarItemsLinks: academiesItems,
    itemLinkSidebarItems: [
      {
        title: "Main Info",
        icon: <AcademyMainInfoIcon />,
        link: "/main-info",
      },
      {
        title: "Structure",
        icon: <AcademyStructureIcon />,
        link: "/structure",
      },
      {
        title: "Subscription Plans",
        icon: <AcademySubscriptionPlansIcon />,
        link: "/subscription-plans",
      },
      // {
      //   title: "Seasons",
      //   icon: <AcademySeasonIcon />,
      //   link: "/seasons",
      // },
      {
        title: "Assets Management",
        icon: <AcademyAssetsIcon />,
        link: "/assets-management",
      },
      {
        title: "Trainers Management",
        icon: <AcademyTrainersIcon />,
        link: "/trainers-management",
      },
      {
        title: "Assessments",
        icon: <AcademyAssetsIcon />,
        link: "/assessments",
      },
      {
        title: "Reports Management",
        icon: <AcademyAssetsIcon />,
        link: "/reports-management",
      },
      {
        title: "Bookings",
        icon: <AcademyBookingIcon />,
        link: "/bookings",
      },
      {
        title: "Calendar",
        icon: <AcademyCalenderIcon />,
        link: "/calendar",
      },

      {
        title: "Waiting List",
        icon: <AcademyWaitingListIcon />,
        link: "/waiting-list",
      },
      {
        title: "Requests",
        icon: <GitPullRequest />,
        link: "/requests",
      },
      {
        title: "Level Up Requests",
        icon: <CornerLeftUpIcon />,
        link: "/level-up-requests",
      },
      {
        title: "Cancellation",
        icon: <CancellationReasonsIcon />,
        link: "/cancellations",
      },
      // {
      //   title: "Ratings & Reviews",
      //   icon: <AcademyRatingsAndReviewIcon />,
      //   link: "/ratings-and-reviews",
      // },
    ],
    url: "academies",
  },
  {
    title: "Performance Plus",
    icon: <TrainingIcon />,
    sidebarItemsLinks: performancePlusItems,
    url: "performance-plus",
    itemLinkSidebarItems: [
      {
        title: "Main Info",
        link: "/main-info",
      },
      {
        title: "Service Management",
        link: "/service-management",
      },
      {
        title: "Instructors Management",
        link: "/instructors-management",
      },
      {
        title: "Packages Management",
        link: "/packages-management",
      },
      {
        title: "Packages Cancellation Requests",
        link: "/packages-cancellation-requests",
      },
      {
        title: "Assets Management",
        link: "/assets-management",
      },
      {
        title: "Bookings",
        link: "/bookings",
      },
      // {
      //   title: "Cancellation",
      //   link: "/cancellations",
      // },
      {
        title: "Calendar",
        link: "/calendar",
      },
      // {
      //   title: "Waiting List",
      //   link: "/waiting-list",
      // },
      // { title: "Ratings & Reviews", link: "/ratings-and-reviews" },
    ],
  },
  {
    title: "Gym",
    icon: <GymIcon />,
    sidebarItemsLinks: gymItems,
    url: "gym",
  },
  // {
  //   title: "Events",
  //   icon: <EventsIcon />,
  //   sidebarItemsLinks: eventsItems,
  //   url: "events",
  // },
  // {
  //   title: "News & Articles",
  //   icon: <ArticlesIcon />,
  //   sidebarItemsLinks: newsAndArticlesItems,
  //   url: "news-articles",
  // },
  {
    title: "divider",
  },
  {
    title: "Report a Bug",
    icon: <BugIcon />,
    link: "https://forms.clickup.com/36276305/f/12k22h-132375/L03YP3NTZNDB7F21L7?Club=xxxxx",
    newTab: true,
  },
  {
    title: "Documentation",
    icon: <DocIcon />,
    link: "https://www.google.com/",
    newTab: true,
  },
] as SideBarItem[];
